import "./StatCard.css";
import { getDefaultIconMapper } from "./constants/StatCardConstants";
import { normalizeMetrics } from "./utility/common";

const StatsCards = ({metricsArray, iconMapper: customIconMapper}) => {
  const iconMapper = customIconMapper || getDefaultIconMapper();
  const normalizedMetrics = normalizeMetrics(metricsArray);

  return (
    <div className="stats-cards-container">
      {normalizedMetrics?.length > 0 && normalizedMetrics.map(([key, metric]) => {
        const formattedTitle = key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());

        const icon = iconMapper[key];
        const iconContainerClass = key === "totalScheduledInterview" 
          ? "stats-card-icon-container stats-card-icon-purple"
          : "stats-card-icon-container stats-card-icon-blue";

        return (
          <div key={key} className="stats-card">
             <span className="stats-card-badge">Last 1 Month</span>
            <div className="stats-card-content">
              <div>
                <p className="stats-card-title">
                  {formattedTitle}
                </p>
                <p className="stats-card-value">
                  {metric.current ?? 0}
                </p>
              </div>
              {icon && (
                <div className={iconContainerClass}>
                {icon}
              </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
